import apiCall, { makeUrl } from "../../utils/apiCall";
import { put } from "redux-saga/effects";

export function* uploadImage({ photoBinaryString, contentType, placeholderImage = null }) {
  yield put({ type: "SET_LOADING", key: "upload-image", loading: true });
  const postImageCall = yield apiCall();
  const result = yield postImageCall.post(makeUrl("/image"), {
    photoBinaryString,
    contentType,
    placeholderImage,
  });
  yield put({ type: "SAVE_TEMPORARY_IMAGE", newImage: result.data.newImage });
  yield put({ type: "SET_LOADING", key: "upload-image", loading: false });
}

export function* uploadFeedEpisodeImage({ feedId, feedEpisodeId, photoBinaryString, contentType }) {
  yield put({ type: "SET_LOADING", key: "upload-episode-image", loading: true });
  const patchImageCall = yield apiCall();
  const result = yield patchImageCall.patch(makeUrl(`/feed-episode/image`), {
    feedId,
    feedEpisodeId,
    photoBinaryString,
    contentType,
  });
  yield put({
    type: "SAVE_FEED_EPISODE_IMAGE",
    feedId,
    feedEpisodeId,
    imageId: result.data.image_id,
    image: result.data.s3_key,
  });
  yield put({ type: "SET_LOADING", key: "upload-episode-image", loading: false });
}

export function* deleteFeedEpisodeImage({ feedId, feedEpisodeId }) {
  yield put({ type: "SET_LOADING", key: "delete-episode-image", loading: true });
  const deleteImageCall = yield apiCall();
  yield deleteImageCall.delete(
    makeUrl(`/feed-episode/image?feedId=${feedId}&feedEpisodeId=${feedEpisodeId}`),
  );
  yield put({
    type: "SAVE_FEED_EPISODE_IMAGE",
    feedId,
    feedEpisodeId,
    imageId: null,
    image: null,
  });
  yield put({ type: "SET_LOADING", key: "delete-episode-image", loading: false });
}
